import { render, staticRenderFns } from "./desinslavedialog.vue?vue&type=template&id=a1f4f606&scoped=true&"
import script from "./desinslavedialog.vue?vue&type=script&lang=js&"
export * from "./desinslavedialog.vue?vue&type=script&lang=js&"
import style0 from "./desinslavedialog.vue?vue&type=style&index=0&id=a1f4f606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f4f606",
  null
  
)

export default component.exports